import { environment } from "../environments/environment";
import { WebSocketService } from "./shared/services/web-socket.service";

export function initializeWebSocket(webSocketService: WebSocketService): () => Promise<void> {
  return (): Promise<void> => {
    const token = localStorage.getItem('token');
    if (token) {
      return new Promise<void>((resolve) => {
        webSocketService.start(environment.WS_URL, { type: 'token', value: `${token}` });
        resolve();
      });
    } else {
      return Promise.resolve();
    }
  };
}
